import moment from 'moment';
import { DocumentState } from 'src/store/types';
import { TableRowInterface } from './PPDocumentListingTable';

export const dataMapper = (
  documentData: DocumentState[],
): TableRowInterface[] => {
  return documentData.map((document) => {
    const { createdAt, id, name } = document;
    return {
      id,
      name,
      createdAt: moment(createdAt).format('MM-DD-YYYY'),
    };
  });
};
